<template>
  <sweet-modal title="Edit Credit Card Account" blocking ref="modal" class="modal" v-on:close="close" width="700">
    <el-form :model="form" size="mini" ref="form" status-icon :rules="rules" label-position="left" label-width="200px">
      <el-form-item label="Credit Limit" prop="creditLimit">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <money v-model="form.creditLimit" class="amount-input" v-bind="money"></money>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Reconcillation" prop="reconciliationDays">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input placeholder="Every (Days)" type="number" v-model="form.reconciliationDays" ></el-input>
          </el-col>
          <el-col :span="12">
            <el-date-picker
                v-model="form.reconcillationStartDate"
                format="d MMM yy"
                value-format="timestamp"
                type="date"
                placeholder="Start Date">
            </el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Financial Institution" prop="financialInstitution">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input v-model="form.financialInstitution"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Website" prop="website">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input placeholder="URL" v-model="form.website"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Account Number" prop="accountNumber">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input v-model="form.accountNumber"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <h3>Bank Manager</h3>
      <el-form-item label="Full Name" prop="bankManagerName">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input placeholder="Name" v-model="form.bankManagerName"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Email" prop="bankManagerEmail">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input v-model="form.bankManagerEmail"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Phone" prop="bankManagerPhone">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input v-model="form.bankManagerPhone"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="Fax" prop="BankManagerFax">
        <el-row :span="24" :gutter="20" style="display: flex;">
          <el-col :span="12">
            <el-input v-model="form.BankManagerFax"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <el-button size="large" @click="update('form')" type="primary">{{$t('general_save')}}</el-button>
      </el-form-item>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios';
import { Money, VMoney } from 'v-money'

export default {
  name: "EditCreditCardAccountModal",
  components: { SweetModal, Money },
  directives: { money: VMoney },
  data: vm => {
    return {
      form: vm.initialForm(),
      rules: {},
      money: {
        precision: 2,
        decimal: '.',
        thousands: ',',
        suffix: '',
        masked: false
      },
    }
  },
  methods: {
    openModal(row) {
      console.log(row)
      this.form.accountId = row.creditCardAccount.id
      this.form.creditLimit = row.creditCardAccount.creditLimit
      this.form.reconciliationDays = row.creditCardAccount.reconciliationDays
      this.form.reconcillationStartDate = row.creditCardAccount.reconciliationStartDate
      this.form.financialInstitution = row.creditCardAccount.financialInstitution
      this.form.website = row.creditCardAccount.website
      this.form.accountNumber = null
      this.form.bankManagerName = row.creditCardAccount.bankManagerName
      this.form.bankManagerEmail = row.creditCardAccount.bankManagerEmail
      this.form.bankManagerPhone = row.creditCardAccount.bankManagerPhone
      this.form.BankManagerFax = row.creditCardAccount.BankManagerFax
      this.$refs.modal.open()
    },
    update(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          const payload = {
            creditLimit: this.form.creditLimit,
            reconciliationDays: this.form.reconciliationDays,
            reconciliationStartDate: this.form.reconcillationStartDate,
            financialInstitution: this.form.financialInstitution,
            website: this.form.website,
            accountNumber: this.form.accountNumber,
            bankManagerName: this.form.bankManagerName,
            bankManagerEmail: this.form.bankManagerEmail,
            bankManagerPhone: this.form.bankManagerPhone,
            BankManagerFax: this.form.BankManagerFax,
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/creditCardAccount/update?accountId=${this.form.accountId}`, payload).then(data => {
            this.$emit('loadList')
            this.$refs.modal.close()
            loader.hide()
          }).catch(error => {
            loader.hide()
            this.$notify({
              title: 'Notification',
              message: error.response.data.message,
              type: 'info'
            })
          })
        }
      })
    },
    close() {

    },
    initialForm() {
      return {
        accountId: null,
        creditLimit: 0,
        reconciliationDays: null,
        reconcillationStartDate: null,
        financialInstitution: null,
        website: null,
        accountNumber: null,
        bankManagerName: null,
        bankManagerEmail: null,
        bankManagerPhone: null,
        BankManagerFax: null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.amount-input {
  display: block;
  resize: vertical;
  padding: 0 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 200px;
  font-size: inherit;
  color: #606266;
  background-color: #FFF;
  background-image: none;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  height: 33px;
  &:focus {
    outline: 0;
    border-color: #409EFF;
  }
}
</style>